import { Vue } from "vue-class-component";
import { Emit, Model } from "vue-property-decorator";
import format from "date-fns/format";
import {
    APIResponse,
    OrderPaymentDetailsDto,
    OrderVehiclePaymentLinkDto,
    PaymentDto,
    PaymentMollieMetadataDto,
} from "@/shared/api-contract/api-contract";
import { appAxios } from "@/core/utils/appAxios";

export class PaymentsTransactionsPopup extends Vue {
    @Model("_orderId", { required: true })
    orderId!: number;
    @Model("_orderPaymentDto", { required: true })
    orderPaymentDto!: OrderPaymentDetailsDto;
    @Emit("cancelPaymentsTransactionsPopup")
    cancelPaymentsTransactionsPopup() {}

    orderVehiclePaymentLinkDto: OrderVehiclePaymentLinkDto[] = [];
    isPending = true;
    isVisible: Record<number, boolean> = {};
    paymentDto: PaymentDto | null = null;
    paymentMollieMetadata: PaymentMollieMetadataDto | null = null;
    positionOne = 0;

    formatDate(_date?: number | bigint, formatString: string = "dd/MM/yyyy"): string {
        if (!_date) return "DD/MM/YYYY";
        if (typeof _date !== "number") {
            return "Invalid date";
        }
        const date = new Date(_date * 1000);

        return format(date, formatString);
    }

    getPosition(value: number) {
        if (this.orderPaymentDto.order_total_amount_including_vat !== null) {
            return (value / this.orderPaymentDto.order_total_amount_including_vat) * 100;
        }
        return 0;
    }
    get dot1Position() {
        let dotPosition1 = this.getPosition(this.orderPaymentDto?.amount_paid_confirmed);
        this.positionOne = dotPosition1;
        return dotPosition1 + "%";
    }

    get dot2Position() {
        let dotPosition2 = this.getPosition(this.orderPaymentDto.amount_paid_pending);
        dotPosition2 = dotPosition2 > 0 ? dotPosition2 + this.positionOne : dotPosition2;
        return dotPosition2 + "%";
    }

    async cancelPayment(paymentId) {
        const response = await appAxios.value.post<APIResponse<PaymentDto>>(
            `/client/web/orders/${this.orderId}/payments/${paymentId}/cancel`,
        );

        if (response.data.status.code === 200) {
            const newPaymentDto = response.data.data;
            const index = this.orderPaymentDto?.payments.findIndex(
                (payment) => payment.id === newPaymentDto.id,
            );
            if (index !== undefined) {
                this.orderPaymentDto?.payments.splice(index, 1, newPaymentDto);
                this.paymentDto = newPaymentDto;
            }
        }
        this.cancelPaymentsTransactionsPopup();
    }
    async proceedPayment(paymentId) {
        await appAxios.value
            .get<APIResponse<PaymentMollieMetadataDto>>(
                `/client/web/orders/${this.orderId}/payments/${paymentId}/mollie-metadata`,
            )
            .then((response) => {
                if (response.data.status.code === 200) {
                    this.paymentMollieMetadata = response.data.data;
                    window.open(
                        `${this.paymentMollieMetadata?.checkout_url_href}`,
                        "_blank",
                    );
                    this.$emit("closePaymentsTransactionsPopup");
                }
            });
    }
    async visible(index, id) {
        if (id !== null) {
            await appAxios.value
                .get<APIResponse<OrderVehiclePaymentLinkDto[]>>(
                    `/client/web/orders/${this.orderId}/payments/${id}/vehicles`,
                )
                .then((response) => {
                    if (response.data.status.code === 200) {
                        this.orderVehiclePaymentLinkDto = response.data.data;
                    }
                });
        }
        this.isVisible[index] = !this.isVisible[index];
    }
}
